var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.481,
    height: 12.483,
    viewBox: "0 0 12.481 12.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2711",
    "data-name": "Group 2711",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M11.451,1.322a2.182,2.182,0,0,1,1.543,3.725L5.259,12.78a.561.561,0,0,1-.249.145l-3.151.859A.561.561,0,0,1,1.17,13.1l.859-3.151a.561.561,0,0,1,.145-.249L9.908,1.961A2.167,2.167,0,0,1,11.451,1.322ZM4.571,11.881,12.2,4.252a1.059,1.059,0,1,0-1.5-1.5L3.073,10.383l-.562,2.059Z",
    transform: "translate(-1.15 -1.322)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.41743b31722cd2533a28d4affb26a8f8.svg";
export { ForwardRef as ReactComponent };